<script>
import TreeNode from 'primevue/tree/TreeNode'
import { DomHandler } from 'primevue/utils'
export default {
    name: 'treenode_extended',
    extends: TreeNode,
    props: {
        multipleNodeSelection: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        propagateDown (node, check, selectionKeys) {
            if (check) {
                selectionKeys[node.key] = { checked: true, partialChecked: false }
            } else {
                delete selectionKeys[node.key]
            }

            // Seule différence avec la version d'origine : présence de this.multipleNodeSelection dans la condition
            if (this.multipleNodeSelection && node.children && node.children.length) {
                for (let child of node.children) {
                    this.propagateDown(child, check, selectionKeys)
                }
            }
        },
        setAllNodesTabIndexes() {
            const nodes = DomHandler.find(this.$refs.currentNode.closest('[data-pc-section="container"]'), '[role="treeitem"]');
            const hasSelectedNode = [...nodes].some((node) => node.getAttribute('aria-selected') === 'true' || node.getAttribute('aria-checked') === 'true');

            [...nodes].forEach((node) => {
                node.tabIndex = -1;
            });

            if (hasSelectedNode) {
                const selectedNodes = [...nodes].filter((node) => node.getAttribute('aria-selected') === 'true' || node.getAttribute('aria-checked') === 'true')

                selectedNodes[0].tabIndex = 0;

                return;
            }

            if (nodes.length > 0) {
                [...nodes][0].tabIndex = 0;
            }
        }
    }
}
</script>

